/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import BaseResponse from '../model/BaseResponse';
import SettlementControllerDtoDoSettlementRequest from '../model/SettlementControllerDtoDoSettlementRequest';
import SettlementControllerDtoDoSettlementResponse from '../model/SettlementControllerDtoDoSettlementResponse';
import SettlementControllerDtoListSettlementRequest from '../model/SettlementControllerDtoListSettlementRequest';
import SettlementControllerDtoListSettlementResponse from '../model/SettlementControllerDtoListSettlementResponse';

/**
* PerplayDailySettlement service.
* @module api/PerplayDailySettlementApi
* @version 1.0
*/
export default class PerplayDailySettlementApi {

    /**
    * Constructs a new PerplayDailySettlementApi. 
    * @alias module:api/PerplayDailySettlementApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the apiPerplayDailySettlementDoSettlementApiPost operation.
     * @callback module:api/PerplayDailySettlementApi~apiPerplayDailySettlementDoSettlementApiPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SettlementControllerDtoDoSettlementResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SettlementControllerDtoDoSettlementRequest} [settlementControllerDtoDoSettlementRequest] 
     * @param {module:api/PerplayDailySettlementApi~apiPerplayDailySettlementDoSettlementApiPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SettlementControllerDtoDoSettlementResponse}
     */
    apiPerplayDailySettlementDoSettlementApiPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['settlementControllerDtoDoSettlementRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = SettlementControllerDtoDoSettlementResponse;
      return this.apiClient.callApi(
        '/api/PerplayDailySettlement/DoSettlementApi', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayDailySettlementDoSettlementPost operation.
     * @callback module:api/PerplayDailySettlementApi~apiPerplayDailySettlementDoSettlementPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SettlementControllerDtoDoSettlementResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SettlementControllerDtoDoSettlementRequest} [settlementControllerDtoDoSettlementRequest] 
     * @param {module:api/PerplayDailySettlementApi~apiPerplayDailySettlementDoSettlementPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SettlementControllerDtoDoSettlementResponse}
     */
    apiPerplayDailySettlementDoSettlementPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['settlementControllerDtoDoSettlementRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = SettlementControllerDtoDoSettlementResponse;
      return this.apiClient.callApi(
        '/api/PerplayDailySettlement/DoSettlement', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayDailySettlementListSettlementApiPost operation.
     * @callback module:api/PerplayDailySettlementApi~apiPerplayDailySettlementListSettlementApiPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SettlementControllerDtoListSettlementResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SettlementControllerDtoListSettlementRequest} [settlementControllerDtoListSettlementRequest] 
     * @param {module:api/PerplayDailySettlementApi~apiPerplayDailySettlementListSettlementApiPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SettlementControllerDtoListSettlementResponse}
     */
    apiPerplayDailySettlementListSettlementApiPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['settlementControllerDtoListSettlementRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = SettlementControllerDtoListSettlementResponse;
      return this.apiClient.callApi(
        '/api/PerplayDailySettlement/ListSettlementApi', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayDailySettlementListSettlementPost operation.
     * @callback module:api/PerplayDailySettlementApi~apiPerplayDailySettlementListSettlementPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SettlementControllerDtoListSettlementResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SettlementControllerDtoListSettlementRequest} [settlementControllerDtoListSettlementRequest] 
     * @param {module:api/PerplayDailySettlementApi~apiPerplayDailySettlementListSettlementPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SettlementControllerDtoListSettlementResponse}
     */
    apiPerplayDailySettlementListSettlementPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['settlementControllerDtoListSettlementRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = SettlementControllerDtoListSettlementResponse;
      return this.apiClient.callApi(
        '/api/PerplayDailySettlement/ListSettlement', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }


}
